/**
 * Footer Component
 * Three-column layout with company info, quick links, and contact details
 * Social media icons and copyright information
 * Appears on every page
 */

import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaInstagram,
  FaLinkedin
} from 'react-icons/fa';
import './Footer.css';
import logo from '../assets/logo.png'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Column 1: About Us */}
        <div className="footer-column">
          <h3 className="footer-heading">SJ Polyzen Industries</h3>
          <div className='footer-logo-placeholder'>
            <img src={logo} alt='SJ Polyzen Industries' className='footer-logo-img' />
          </div>
          <p className="footer-description">
            Manufacturer of recycled PPCP injection-grade granules, delivering consistent
            quality and reliable supply for injection moulding applications since 2025.
          </p>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-column">
          <h3 className="footer-heading">Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/products">Our Products</Link></li>
            <li><Link to="/quality">Quality Policy</Link></li>
            <li><Link to="/applications">Applications</Link></li>
            <li><Link to="/catalogue">Catalogue</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Column 3: Contact Us */}
        <div className="footer-column">
          <h3 className="footer-heading">Contact Us</h3>
          <div className="footer-contact">
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <div>
                <p><b>Office</b>: 34 Nehru Nagar, Dewas,</p>
                <p> Madhya Pradesh- 455001</p>
                <p><b>Godown</b>: Sector 110, Bajghera, Gurgaon</p>

              </div>
            </div>

            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <div>
                <a href="mailto:admin@sjpolyzen.com">admin@sjpolyzen.com</a>
                <a href="mailto:support@sjpolyzen.com">support@sjpolyzen.com</a>
              </div>
            </div>

            <div className="contact-item">
              <FaPhoneAlt className="contact-icon" />
              <div>
                <a href="tel:+918719824566">+91 7827573340</a>
              </div>
            </div>

            {/* Social Media Icons */}
            <div className="social-icons">
              {/* TODO: Add actual Instagram and LinkedIn URLs */}
              <a
                href="https://urldefense.com/v3/__https://instagram.com__;!!OiUq6JES4A!gv0t1odtvO0GtrwANjq0rXPxwcpup5jlRM0fPTMH-S9FfCrh9n09F0A_MhITIqzn0SvSsYqUTkrpBr5ffm7Y3gKBmzR7CtM$ "
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://urldefense.com/v3/__https://www.linkedin.com/company/sj-polyzen/__;!!OiUq6JES4A!gv0t1odtvO0GtrwANjq0rXPxwcpup5jlRM0fPTMH-S9FfCrh9n09F0A_MhITIqzn0SvSsYqUTkrpBr5ffm7Y3gKBSQZ1bwI$ "
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p>&copy; 2025 SJ Polyzen Industries. All Rights Reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="separator">|</span>
            <Link to="/terms">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;